import React, { useState } from "react";
import PropTypes from "prop-types";
import burgerIcon from "../../assets/icon_burger.svg";
import "./styles.scss";

const ButtonHeaderMobile = ({ listMenu, handleRoute, handleLogout }) => {
  const [showOptions, setShowOptions] = useState(false);

  const handleShowOptions = (value) => {
    setShowOptions(value);
  };

  return (
    <>
      <div
        className="buttonheadermobile d-flex-center"
        onClick={() => handleShowOptions(!showOptions)}
      >
        <img src={burgerIcon} alt="burger icon" />
      </div>
      {showOptions && (
        <ul className="buttonheadermobile-menu">
          {listMenu
            .filter((elem) => elem.showIntoMenu)
            .map((elem) => (
              <li
                key={elem.id}
                className="paragraph paragraph-14 text-center"
                onClick={() => handleRoute(elem.path)}
              >
                {elem.name}
              </li>
            ))}
          <li
            className="paragraph paragraph-14 text-center"
            onClick={handleLogout}
          >
            Cerrar sesión
          </li>
        </ul>
      )}
    </>
  );
};

ButtonHeaderMobile.defaultProps = {
  listMenu: [],
};

ButtonHeaderMobile.propTypes = {
  listMenu: PropTypes.array,
};

export default ButtonHeaderMobile;
